import type { SVGProps } from "react";
const SenecPictogramCoWorking = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 6C11.5523 6 12 6.44772 12 7V11.0825C14.2763 11.5051 16 13.5012 16 15.9V17H6V15.9C6 13.5012 7.72367 11.5051 10 11.0825V7C10 6.44772 10.4477 6 11 6ZM8.14237 15H13.8576C13.479 13.839 12.3875 13 11.1 13H10.9C9.61255 13 8.52104 13.839 8.14237 15Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37 6C37.5523 6 38 6.44772 38 7V11.0825C40.2763 11.5051 42 13.5012 42 15.9V17H32V15.9C32 13.5012 33.7237 11.5051 36 11.0825V7C36 6.44772 36.4477 6 37 6ZM34.1424 15H39.8576C39.479 13.839 38.3875 13 37.1 13H36.9C35.6125 13 34.521 13.839 34.1424 15Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 20H22V26H26V20H37V26H42V41C42 41.5523 41.5523 42 41 42C40.4477 42 40 41.5523 40 41V28H8V33C8 33.5523 7.55228 34 7 34C6.44772 34 6 33.5523 6 33V26H11V20ZM13 26H20V22H13V26ZM35 26V22H28V26H35Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 33C11 31.3431 12.3431 30 14 30H20C21.6569 30 23 31.3431 23 33C23 34.6569 21.6569 36 20 36H18V40H21V42H13V40H16V36H14C12.3431 36 11 34.6569 11 33ZM14 32C13.4477 32 13 32.4477 13 33C13 33.5523 13.4477 34 14 34H20C20.5523 34 21 33.5523 21 33C21 32.4477 20.5523 32 20 32H14Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 33C25 31.3431 26.3431 30 28 30H34C35.6569 30 37 31.3431 37 33C37 34.6569 35.6569 36 34 36H32V40H35V42H27V40H30V36H28C26.3431 36 25 34.6569 25 33ZM28 32C27.4477 32 27 32.4477 27 33C27 33.5523 27.4477 34 28 34H34C34.5523 34 35 33.5523 35 33C35 32.4477 34.5523 32 34 32H28Z"
            fill="currentColor"
        />
        <path
            d="M7 37C7.55228 37 8 37.4477 8 38V41C8 41.5523 7.55228 42 7 42C6.44772 42 6 41.5523 6 41V38C6 37.4477 6.44772 37 7 37Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramCoWorking;
